// extracted by mini-css-extract-plugin
export default {"bottom_server_section":"bottomserver_bottom_server_section__GxMKu","bottom_container":"bottomserver_bottom_container__DIwU9"};